import * as React from "react";
import { ConsultationPrescriptionItemRequest } from "@curefit/gmf-common";
import {IDoctorCheckInInfo} from "@curefit/care-common";
import {default as AppUtils, EpochConstants, LOADING_STATE} from "../../utils/AppUtils"
import EditViewCard, {EditViewDisplayMode} from "../../components/common/EditViewCard"
import AppLoader from "../../components/utils/AppLoader"
import * as _ from "lodash"
import ModelFactory from "../../models/ModelFactory"
import {PatientAdditionalInstructionsEditorProps} from "../../components/patient/edit/PatientAdditionalInstructionsEditor";
import {AppConstants, CheckinType} from "../../utils/AppConstants";
import {AdditionalInstructionsViewProps} from "../../components/patient/view/AdditionalInstructionsView";
import IDoctorProfile from "../../models/IDoctorProfile";
import {IFollowup, IReferral} from "../../models/LCPlanClientModels";

/**
 * Created by aditya on 08/02/18.
 */

export interface AdditionalInstructionsEditViewContProps {
    consultationType?: string,
    patientId: number,
    secondaryPatientId: string,
    immediateFollowUp?: boolean,
    patientReferrals: IReferral[],
    patientFollowUp: IFollowup[],
    fetchPatientReferrals?: (patientId: number) => any,
    savePatientReferrals?: (patientId: number, referrals: IDoctorCheckInInfo[]) => any,
    fetchPatientFollowUps?: (patientid: number) => any,
    savePatientFollowUps?: (patientid: number, followUps: IDoctorCheckInInfo) => any,
    updateImmediateFollowUp?: () => void,
    staticSpecialities: any[],
    displayMode?: EditViewDisplayMode,
    doctorType?: string;
    consultationId: number;
    doctorProfile: IDoctorProfile;
    isSelf: boolean;
}

export interface AdditionalInstructionsEditViewContState {
    updatedFollowUp: {item: IFollowup}[],
    updatedReferral: {item: IReferral}[],
    immediateFollowUp: boolean,
    isPatientReferralDataLoaded: LOADING_STATE,
    isPatientFollowUpDataLoaded: LOADING_STATE
}

class AdditionalInstructionsEditViewCont extends React.Component<AdditionalInstructionsEditViewContProps, AdditionalInstructionsEditViewContState> {

    constructor(props: AdditionalInstructionsEditViewContProps) {
        super(props);
        this.state = this.getStateFromProps(props);
    }

    componentWillReceiveProps(props: AdditionalInstructionsEditViewContProps) {
        this.setState(this.getStateFromProps(props));
    }

    getUpdatedAdditionalInfoFromProps = (props: AdditionalInstructionsEditViewContProps): {item: IDoctorCheckInInfo}[] => {
        let currUpdatedReferrals: {item: IDoctorCheckInInfo}[] = [];
        _.map(props.patientReferrals, function(referral){
            let clonePatientReferrals = Object.assign({}, referral);
            currUpdatedReferrals.push({item: clonePatientReferrals});
        });
        return currUpdatedReferrals;
    }

    getStateFromProps = (props: AdditionalInstructionsEditViewContProps) => {
        let currState: AdditionalInstructionsEditViewContState = {
            updatedFollowUp: [],
            updatedReferral: [],
            immediateFollowUp: props.immediateFollowUp,
            isPatientReferralDataLoaded: LOADING_STATE.NOT_INITIALIZED,
            isPatientFollowUpDataLoaded: LOADING_STATE.NOT_INITIALIZED
        }
        if ( _.isNull(props.patientReferrals)) {
            props.fetchPatientReferrals(this.props.patientId);
            currState.isPatientReferralDataLoaded = LOADING_STATE.LOADING;
        } else {
            currState.updatedReferral = _.map(props.patientReferrals, (item: IReferral) => ({item}));
            currState.isPatientReferralDataLoaded = LOADING_STATE.LOADED;
        }
        if ( _.isNull(props.patientFollowUp)) {
            props.fetchPatientFollowUps(this.props.patientId);
            currState.isPatientFollowUpDataLoaded = LOADING_STATE.LOADING;
        } else {
            currState.updatedFollowUp = _.map(props.patientFollowUp, (item: IFollowup) => ({item}));
            currState.isPatientFollowUpDataLoaded = LOADING_STATE.LOADED;
        }
        return currState;
    }

    getReferralEditViewTemplateProps = () => {
        let patientReferralViewProps: AdditionalInstructionsViewProps = {
            patientReferrals: this.props.patientReferrals,
            staticSpecialities: this.props.staticSpecialities
        }
        let patientReferralEditorProps: PatientAdditionalInstructionsEditorProps = {
            consultationType: this.props.consultationType,
            immediateFollowUp: this.state.immediateFollowUp,
            updatedFollowUp: !_.isEmpty(this.state.updatedFollowUp) ? this.state.updatedFollowUp : [{item: null}],
            updateSavedReferrals: this.updateSavedPatientReferral,
            updatedReferral: this.state.updatedReferral.length ? this.state.updatedReferral : [],
            updateReferral: this.updatePatientReferral,
            updateFollowUp: this.updatePatientFollowUp,
            updateImmediateFollowUp: this.updateImmediateFollowUp,
            staticSpecialities: this.props.staticSpecialities
        }
        return {"view": patientReferralViewProps, "edit": patientReferralEditorProps};
    }

    updatePatientFollowUp = (updatedFollowUp: {item: IFollowup}[]) => {
        this.setState({updatedFollowUp});
    }

    updatePatientReferral = (updatedReferral: {item: IReferral}[]) => {
        this.setState({updatedReferral});
    }

    updateImmediateFollowUp = () => {
        this.setState({ immediateFollowUp: !this.state.immediateFollowUp });
    }

    cancelActionHandler = () => {
        this.setState({updatedReferral: this.getUpdatedAdditionalInfoFromProps(this.props)});
    }

    savePatientAdditionalInstructions = () => {
        this.savePatientReferral();
        this.savePatientFollowUp();
    }

    savePatientReferral = () => {
        let myInstance = this;
        let saveReferralList: IDoctorCheckInInfo[] = this.getReferralSaveObject();
        if (saveReferralList.length > 0) {
            this.setState({isPatientReferralDataLoaded: LOADING_STATE.NOT_INITIALIZED})
            this.props.savePatientReferrals(this.props.patientId, saveReferralList).then(function(){
                myInstance.setState({isPatientReferralDataLoaded: LOADING_STATE.LOADED})
            });
        }
    }

    savePatientFollowUp = () => {
        let myInstance = this;
        let saveFollowUp: IDoctorCheckInInfo = this.getFollowUpSaveObject() as any;
        this.setState({isPatientFollowUpDataLoaded: LOADING_STATE.NOT_INITIALIZED})
        this.props.savePatientFollowUps(this.props.patientId, saveFollowUp).then(function(){
            myInstance.setState({isPatientFollowUpDataLoaded: LOADING_STATE.LOADED})
        });
    }

    getReferralSaveObject = (): IReferral[] => {
        let saveReferralList: IReferral[] = [];
        _.map(this.state.updatedReferral, (updatedReferralItem: {item: IReferral}) => {
            // if (ModelFactory.isValidReferral(updatedReferralItem.item)) {
                saveReferralList.push(updatedReferralItem.item);
            // }
            if (ModelFactory.isReferralItemEmpty(updatedReferralItem.item)) saveReferralList = []
        });
        return saveReferralList;
    }

    getFollowUpSaveObject = (): IFollowup[] => {
        let saveFollowUp: IFollowup[] = !_.isEmpty(this.state.updatedFollowUp) ? this.state.updatedFollowUp.map(followupItem => followupItem.item) : [];
        return !_.isEmpty(saveFollowUp) && !ModelFactory.isFollowUpItemEmpty(saveFollowUp[0]) ? saveFollowUp : [];
    }

    getImmediateFollowUp = (): boolean => {
        return this.state.immediateFollowUp;
    }

    isReferralFormDirty = (): boolean => {
        let status = false;
        _.map(this.state.updatedReferral, (updatedReferralItem: {item: IReferral}) => {
            if (!ModelFactory.isValidReferral(updatedReferralItem.item)) {
                status = true;
                return false;
            }
        })
        return status;
    }

    isFollowUpFormDirty = (): boolean => {
        let status = false;
        let updatedFollowupItem = this.state.updatedFollowUp;
        // _.map(this.state.updatedFollowUp, function(updatedFollowupItem: {item: IDoctorCheckInInfo}){
            if (!_.isEmpty(updatedFollowupItem) && !ModelFactory.isValidFollowUp(updatedFollowupItem[0].item)) {
                status = true;
            }
        // })
        return status;
    }

    getConsultationPlanSaveObject = () => {
        let myInstance = this;
        let saveReferralList: ConsultationPrescriptionItemRequest[] = [];
        const {id, name} = this.props.doctorProfile;
        const {consultationId, doctorType} = this.props;
        let sourceMapDocType = AppUtils.getPlanMetaDoctorType(doctorType);
        _.map(this.state.updatedReferral, function(updatedReferralItem: {item: IDoctorCheckInInfo}){
            let consultationPlanActivity = ModelFactory.createNewConsultationPlanActivity();
            const hasDoctorType = !_.isEmpty(updatedReferralItem.item.doctorType);
            consultationPlanActivity.compliance = "RECOMMENDED";
            consultationPlanActivity.quantity = 1;
            consultationPlanActivity.checkinType = CheckinType.REFERRAL;
            consultationPlanActivity.doctorType = hasDoctorType ? updatedReferralItem.item.doctorType.code : null;
            consultationPlanActivity.doctorTypeDisplayValue = hasDoctorType && !_.isEmpty(Object.values(myInstance.props.staticSpecialities).filter(item => item.doctorTypeCode === updatedReferralItem.item.doctorType.code)) ? Object.values(myInstance.props.staticSpecialities).filter(item => item.doctorTypeCode === updatedReferralItem.item.doctorType.code)[0].displayText : "";
            consultationPlanActivity.comments = [updatedReferralItem.item.comment];
            if (!_.isEmpty(updatedReferralItem.item.activityDate) && !_.isEmpty(updatedReferralItem.item.activityDate.unit) && updatedReferralItem.item.activityDate.count !== null) {
                let consultationSchedule = ModelFactory.createNewFitnessSchedule();
                consultationSchedule.frequency = 1;
                consultationSchedule.repetition.count = updatedReferralItem.item.activityDate.count;
                consultationSchedule.repetition.unit = updatedReferralItem.item.activityDate.unit;
                consultationPlanActivity.schedule = consultationSchedule;
            }
            let consultationPlanObject = ModelFactory.createNewConsultationPlanPrescriptionItem();
            if (consultationPlanObject.startEpoch === null) {
                consultationPlanObject.startEpoch = new Date().getTime();
                consultationPlanObject.endEpoch = new Date().getTime() + (EpochConstants.EPOCH_IN_AN_DAY * 90);
            }
            consultationPlanObject.activities = [consultationPlanActivity];
            consultationPlanObject.status = AppConstants.planStatus.LIVE;
            consultationPlanObject.onlyGuidelines = false;
            consultationPlanObject.secondaryUserId = myInstance.props.secondaryPatientId.toString();
            consultationPlanObject.isSelf = myInstance.props.isSelf;
            saveReferralList.push(consultationPlanObject);
        });
        _.map(this.state.savedReferrals, (updatedReferralItem: {item: IDoctorCheckInInfo}) => {
            let consultationPlanActivity = ModelFactory.createNewConsultationPlanActivity();
            consultationPlanActivity.compliance = "RECOMMENDED";
            consultationPlanActivity.quantity = 1;
            consultationPlanActivity.checkinType = CheckinType.REFERRAL;
            consultationPlanActivity.doctorType = updatedReferralItem.item.doctorType ? updatedReferralItem.item.doctorType.code : null;
            consultationPlanActivity.doctorTypeDisplayValue = !_.isEmpty(Object.values(myInstance.props.staticSpecialities).filter(item => item.doctorTypeCode === updatedReferralItem.item.doctorType.code)) ? Object.values(myInstance.props.staticSpecialities).filter(item => item.doctorTypeCode === updatedReferralItem.item.doctorType.code)[0].displayText : "";
            consultationPlanActivity.comments = [updatedReferralItem.item.comment];
            if (!_.isEmpty(updatedReferralItem.item.activityDate) && !_.isEmpty(updatedReferralItem.item.activityDate.unit) && updatedReferralItem.item.activityDate.count !== null) {
                let consultationSchedule = ModelFactory.createNewFitnessSchedule();
                consultationSchedule.frequency = 1;
                consultationSchedule.repetition.count = updatedReferralItem.item.activityDate.count;
                consultationSchedule.repetition.unit = updatedReferralItem.item.activityDate.unit;
                consultationPlanActivity.schedule = consultationSchedule;
            }
            let consultationPlanObject = ModelFactory.createNewConsultationPlanPrescriptionItem();
            consultationPlanObject.activities = [consultationPlanActivity];
            consultationPlanObject.status = updatedReferralItem.item.status;
            consultationPlanObject.startEpoch = updatedReferralItem.item.startEpoch;
            consultationPlanObject.endEpoch = updatedReferralItem.item.endEpoch;
            consultationPlanObject.onlyGuidelines = false;
            consultationPlanObject.secondaryUserId = this.props.secondaryPatientId.toString();
            consultationPlanObject.newPlanSource = updatedReferralItem.item.newPlanSource;
            consultationPlanObject._id = updatedReferralItem.item.id;
            saveReferralList.push(consultationPlanObject);
        })

        let saveFollowUp: IDoctorCheckInInfo = this.state.updatedFollowUp !== null ? { ...this.state.updatedFollowUp.item } : null;
        if (!_.isNull(saveFollowUp) && !ModelFactory.isFollowUpItemEmpty(saveFollowUp)) {
            let consultationPlanActivity = ModelFactory.createNewConsultationPlanActivity();
            consultationPlanActivity.compliance = "RECOMMENDED";
            consultationPlanActivity.quantity = 1;
            consultationPlanActivity.checkinType = CheckinType.FOLLOWUP;
            consultationPlanActivity.doctorType = this.props.doctorType;
            consultationPlanActivity.doctorTypeDisplayValue = AppUtils.getSpecialityNameFromCode(this.props.doctorType, this.props.staticSpecialities);
            consultationPlanActivity.comments = [saveFollowUp.comment];
            if (!_.isEmpty(saveFollowUp.activityDate) && !_.isEmpty(saveFollowUp.activityDate.unit) && saveFollowUp.activityDate.count !== null) {
                let consultationSchedule = ModelFactory.createNewFitnessSchedule();
                consultationSchedule.frequency = 1;
                consultationSchedule.repetition.count = saveFollowUp.activityDate.count;
                consultationSchedule.repetition.unit = saveFollowUp.activityDate.unit;
                consultationPlanActivity.schedule = consultationSchedule;
            }
            let consultationPlanObject = ModelFactory.createNewConsultationPlanPrescriptionItem();
            consultationPlanObject.activities = [consultationPlanActivity];
            consultationPlanObject.status = !_.isEmpty(saveFollowUp.status) ? saveFollowUp.status : AppConstants.planStatus.LIVE;
            if (consultationPlanObject.startEpoch === null) {
                consultationPlanObject.startEpoch = new Date().getTime();
                consultationPlanObject.endEpoch = new Date().getTime() + (EpochConstants.EPOCH_IN_AN_DAY * 90);
            }
            consultationPlanObject.onlyGuidelines = false;
            consultationPlanObject.secondaryUserId = this.props.secondaryPatientId.toString();
            consultationPlanObject.isSelf = this.props.isSelf;
            if (consultationPlanObject._id) delete consultationPlanObject._id;
            saveReferralList.push(consultationPlanObject);
        }
        return saveReferralList;
    }

    render() {
        let isSymptomDataLoaded = this.state.isPatientReferralDataLoaded === LOADING_STATE.LOADED;
        return (
            <div className="symptom-editview-cont">
                {
                    isSymptomDataLoaded &&
                    <EditViewCard cardTitleDisplay={"Additional Instruction"} templateName={"additionalInstructions"}
                                  templateProps={this.getReferralEditViewTemplateProps()}
                                  lastEditedEpoch={new Date().getTime()} saveActionHandler={this.savePatientAdditionalInstructions}
                                  cancelActionHandler={this.cancelActionHandler} displayMode={this.props.displayMode}
                    />
                }
                {
                    !isSymptomDataLoaded &&
                    <AppLoader/>
                }
            </div>
        );
    }
}

export default AdditionalInstructionsEditViewCont;